import React from "react";
import { SFTypography, SFStack, SFLink } from "@sf-core";
import { useTranslation, Trans } from "react-i18next";
import { ReactComponent as EyLogo } from "./images/logo.svg";
import { baseContainer } from "@base-provider";

import env from "env";

const LinkText = (props) => (
  <SFLink href={props.href || null} to={props.to || null}>
    {props.text}
  </SFLink>
);

const TryAgainText = (props) => (
  <SFLink
    variant="blue"
    onClick={() => {
      // Clear local storage and session storage and redirect to home page
      // false means that user will not be logged out
      baseContainer.authenticationService.clearStorages(false);
       
      location.href = "/";
    }}
  >
    {props.text}
  </SFLink>
);

const UnAuthorizedScreen = () => {
  const { t } = useTranslation();

  return (
    <SFStack spacing={2} sx={{ width: "90%" }}>
      <EyLogo />
      <SFTypography variant="heroDescription">
        {t("signinScreen.unauthorized.title")}
      </SFTypography>
      <SFTypography variant="body2">
        {t("signinScreen.unauthorized.caption")}
      </SFTypography>
      <SFTypography variant="body2">
        <Trans
          i18nKey="signinScreen.unauthorized.support"
          t={t}
          values={{ supportMail: env.REACT_APP_SUPPORT_EMAIL }}
          components={{ link: <LinkText /> }}
        />
      </SFTypography>
      <SFTypography variant="body2">
        <Trans
          i18nKey="signinScreen.unauthorized.tryAgain"
          t={t}
          components={{ link: <TryAgainText /> }}
        />
      </SFTypography>
    </SFStack>
  );
};

export default UnAuthorizedScreen;
